import React from "react";
import { getTranslateByKey } from "@/main/services/utils";
import { partBrandApi } from "@/main/api";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import RowDataTireBrand from "./rowDataTireBrand/rowDataTireBrand";
import { TireBrandResponse } from "@/main/models/response/tireBrandResponse";
import * as S from "./styles";
import { TireBrandRequest } from "@/main/models/request/tireBrandRequest";

interface IGridSearchTireBrandProps {
	dataGrid: TireBrandResponse[];
	formFilters: TireBrandRequest;
	setDataGrid: React.Dispatch<React.SetStateAction<TireBrandResponse[]>>;
	getDataTireBrand: (filters: TireBrandRequest) => void;
}

function GridSearchTireBrand({ dataGrid, formFilters, setDataGrid, getDataTireBrand }: IGridSearchTireBrandProps) {
	const rowsHeader = [
		getTranslateByKey("information.tireBrand"),
		<S.TextCenter key="1">{getTranslateByKey("information.status")}</S.TextCenter>,
	];
	const RowsGroup = ["responsive", "150px"];
	async function fetchDataTireBrand(request: any) {
		return partBrandApi.getSearchGrid(request).then((response) => response.data);
	}

	if (dataGrid.length === 0 && formFilters === null) return null;

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchDataTireBrand}
				fetchEqualFilters
			>
				<BoxGrid rowHeaders={rowsHeader} sizeColumns={RowsGroup}>
					{dataGrid.map((item) => (
						<RowDataTireBrand
							key={item.guid}
							refreshSearchGrid={() => getDataTireBrand(formFilters)}
							tireBrand={item}
						/>
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridSearchTireBrand;
